'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy(server) {
  this.Lapp_data_OperationalAppRegisteredUser$Pharmacy__f_server = null;
  this.Lapp_data_OperationalAppRegisteredUser$Pharmacy__f_server = server;
}
export { $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy as $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy };
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.constructor = $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy;
/** @constructor */
function $h_Lapp_data_OperationalAppRegisteredUser$Pharmacy() {
}
export { $h_Lapp_data_OperationalAppRegisteredUser$Pharmacy as $h_Lapp_data_OperationalAppRegisteredUser$Pharmacy };
$h_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype = $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype;
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 243544489, true);
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy)) {
    var x = this.Lapp_data_OperationalAppRegisteredUser$Pharmacy__f_server;
    var x$2 = x$0.Lapp_data_OperationalAppRegisteredUser$Pharmacy__f_server;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.productPrefix__T = (function() {
  return "Pharmacy";
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_OperationalAppRegisteredUser$Pharmacy__f_server;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "server";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy.prototype.server__Lapp_data_AppRegisteredUser = (function() {
  return this.Lapp_data_OperationalAppRegisteredUser$Pharmacy__f_server;
});
function $isArrayOf_Lapp_data_OperationalAppRegisteredUser$Pharmacy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_OperationalAppRegisteredUser$Pharmacy)));
}
export { $isArrayOf_Lapp_data_OperationalAppRegisteredUser$Pharmacy as $isArrayOf_Lapp_data_OperationalAppRegisteredUser$Pharmacy };
var $d_Lapp_data_OperationalAppRegisteredUser$Pharmacy = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_OperationalAppRegisteredUser$Pharmacy, "app.data.OperationalAppRegisteredUser$Pharmacy", ({
  Lapp_data_OperationalAppRegisteredUser$Pharmacy: 1,
  Lapp_data_OperationalAppRegisteredUser: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_OperationalAppRegisteredUser$Pharmacy as $d_Lapp_data_OperationalAppRegisteredUser$Pharmacy };
//# sourceMappingURL=app.data.-Operational-App-Registered-User$-Pharmacy.js.map
